import {
  Box,
  Grid,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Typography,
  TextField,
  InputAdornment,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import EditIcon from "@mui/icons-material/Edit";
import React, { useState } from "react";
import { sizes } from "../../setupUtils";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPGDetail,
  getPGForCountry,
  resetAllStates,
  setPGState,
} from "../productGroupSetupSlice";
import Status from "./Status";
import CollapseSection from "../../../../components/ui/CollapseSection";
import SearchIcon from "@mui/icons-material/Search";

export default function SearchPG() {
  const pgState = useSelector((store) => store.productGroupSetup);
  const dispatch = useDispatch();

  const {
    countries,
    country,
    countryID,
    productGroups,
    productGroupName,
    eProductGroupName,
    productGroupID,
    productGroup,
    fromDate,
    toDate,
    status,
    selectedSKUs,
    productGroupNameSearch,
  } = pgState;

  const loginState = useSelector((store) => store.login);
  const { globalSelectedCountryName,globalSelectedCountryID,} = loginState  

  useEffect(() => {
		if(globalSelectedCountryID !== null){
      dispatch(setPGState("countryID", globalSelectedCountryID));
      dispatch(setPGState("pgGlobalCountryID", globalSelectedCountryID));   
      setLocalCountryID(globalSelectedCountryID);     
		}
	},[globalSelectedCountryID])

	useEffect(() => {
		if(globalSelectedCountryName !== null && globalSelectedCountryName !== ""){
      dispatch(setPGState("country", globalSelectedCountryName));    
		}
	},[globalSelectedCountryName])  

  const minDate = dayjs().add(1, "day");

  const [countryIDLocal, setLocalCountryID] = useState("");
  const [productGroupNameSearchLocal, setproductGroupNameSearchLocal] = useState("");


  // useEffect(() => {
  //   if (countryID !== "") {
  //     dispatch(getPGForCountry({ countryID, productGroupNameSearch }));
  //     dispatch(setPGState("productGroupName", ""));
  //   }
  // }, [countryID, productGroupNameSearch]);

  useEffect(() => {
    if (productGroup !== null && Object.keys(productGroup).length > 0) {
      setPGDetails();
    }
  }, [productGroup]);

  useEffect(() => {
    setInitialFilteredData();
  }, []);

  function setInitialFilteredData() {
    dispatch(setPGState("productGroups", []));
  }

  function updateCountry(event) {
    dispatch(resetAllStates({ edit: true }));
    dispatch(setPGState("productGroups", []));
    const name = event.target.value;
    const id = countries.find(
      (country) => country.countryName === name
    ).countryID;
    setLocalCountryID(id);
    dispatch(setPGState("country", name));
    dispatch(setPGState("productGroupNameSearch", ""));
    dispatch(setPGState("countryID", id));
  }

  function updateProductGroup(event) {
    const pg = event.target.value;
    if (pg == "") return;
    const pgID = productGroups.find(
      (pgroup) => pgroup.productGroupName === pg
    ).productGroupID;

    dispatch(setPGState("productGroupName", pg));
    dispatch(setPGState("productGroupID", pgID));
    dispatch(setPGState("eProductGroupName", ""));
    dispatch(setPGState("fromDate", dayjs().add(1, "day")));
    dispatch(setPGState("toDate", dayjs("2099-12-31T00:00:00.000Z")));
    dispatch(setPGState("status", "None"));
    dispatch(setPGState("searchedPGName", ""));
    dispatch(setPGState("skus", []));
    dispatch(setPGState("selectedSKUs", []));
    dispatch(setPGState("comments", ""));
    dispatch(setPGState("files", []));

    if (!pgID) {
      dispatch(setPGState("editMessage", "No product group selected"));
      dispatch(setPGState("editMessageSeverity", "info"));
      dispatch(setPGState("editMessageOpen", true));
      return;
    }
    dispatch(getPGDetail({ productGroupID: pgID }));

  }

  function showPopup(message, severity) {
    dispatch(setPGState("editMessage", message));
    dispatch(setPGState("editMessageSeverity", severity));
    dispatch(setPGState("editMessageOpen", true));
 }

  function getDetailPG() {
    const id = productGroupID;
    // reset all state's when go button is clicked.
    //dispatch(setPGState("countryID", countryIDLocal));
    //dispatch(setPGState("productGroupNameSearch", productGroupNameSearchLocal));
    if (country === "") {
      showPopup("Please select a country.", "info");
      return;
   }

    dispatch(getPGForCountry({ countryID, productGroupNameSearch }));

  }

  function setPGDetails() {
    //const formattedComments = productGroup.comments ? productGroup.comments.replace(/,/g, '\n') : '';
    const formattedComments = productGroup.comments;
    dispatch(setPGState("eProductGroupName", productGroup.productGroupName));
    dispatch(setPGState("fromDate", dayjs(productGroup.effectiveStartDate)));
    dispatch(setPGState("toDate", dayjs(productGroup.effectiveEndDate)));
    dispatch(setPGState("status", productGroup.status));
    dispatch(setPGState("skus", []));
    dispatch(setPGState("selectedSKUs", productGroup.productGroupList));
    dispatch(setPGState("comments", formattedComments));
    dispatch(setPGState("files", productGroup.productGroupFiles));
  }

  function updateEditPGName(event) {
    const name = event.target.value;
    dispatch(setPGState("eProductGroupName", name));
  }

  function updateFromDate(newDate) {
    setSelectedSKUFromDates(newDate);
    dispatch(setPGState("fromDate", newDate));
  }

  function updateToDate(newDate) {
    setSelectedSKUTODates(newDate);
    dispatch(setPGState("toDate", newDate));
  }

  function setSelectedSKUFromDates(date) {
    const selSKUs = selectedSKUs.map((item) => {
      const skustartDate = new Date(item.effectiveStartDate);
      const newDate = new Date(date);
      // return {
      //   ...item,
      //   effectiveStartDate: skustartDate<newDate?date:item.effectiveStartDate, 
      // };
      return {
        ...item,
        effectiveStartDate: (() => {
          if (fromDate === item.effectiveStartDate) {
          return date;
          }
         if (skustartDate < newDate) {
          return date;
          }
          return item.effectiveStartDate;
        })(),
        };      
    });
    dispatch(setPGState("selectedSKUs", selSKUs));
  }

  function setSelectedSKUTODates(date) {
    const selSKUs = selectedSKUs.map((item) => {
      const skuEndDate = new Date(item.effectiveEndDate);
      const newDate = new Date(date);      
      // return {
      //   ...item,
      //   effectiveEndDate: skuEndDate > newDate? date: item.effectiveEndDate, 
      // };
      return {
        ...item,
        effectiveEndDate: (() => {
          if (toDate === item.effectiveEndDate) {
          return date;
          }
         if (skuEndDate > newDate) {
          return date;
          }
          return item.effectiveEndDate;
        })(),
        };      
    });
    dispatch(setPGState("selectedSKUs", selSKUs));
  }

  function setSearchedPGName(event) {
    const name = event.target.value;
    dispatch(setPGState("productGroupNameSearch", name));
    //setproductGroupNameSearchLocal(name);
    //dispatch(setPGState("productGroupNameSearch", name));
  }

  return (
    <Box>
      {/* COUNTRY, PRODUCT GROUP NAME, GO BUTTON */}
      <Box
        sx={{
          mt: 3,
        }}
      >
        <Grid
          container
          columns={12}
          spacing={4}
          justifyContent={"space-between"}
        >
          <Grid item sm={6} md={6} lg={6}>
            <Grid container spacing={2}>
              <Grid item sm={6} md={6} lg={5}>
                <FormControl>
                  <InputLabel>Country</InputLabel>
                  <Select
                    value={country}
                    label="Country"
                    sx={{
                      height: sizes.h35,
                      width: sizes.w270,
                      color: "black.main",
                      mt: 1,
                    }}
                    onChange={updateCountry}
                  >
                    {countries.map((country, index) => {
                      return (
                        <MenuItem key={index} value={country.countryName}>
                          {country.countryName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item sm={6} md={6} lg={5}>
                <FormControl>
                  <TextField
                    label="Product Group Name"
                    value={productGroupNameSearch}
                   // value={productGroupNameSearchLocal}
                    variant="outlined"
                    onChange={setSearchedPGName}
                    sx={{
                      height: sizes.h35,
                      //width: sizes.w270,
                      width: "100%",
                      // color: colors.black,
                      color: "black.main",
                      boxSizing: "border-box",
                    }}
                    InputProps={{ autoComplete: "off" }}
                  />
                </FormControl>
              </Grid>

              <Grid item sm={6} md={6} lg={2}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    //alignItems: "center",
                    height: "100%",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<SearchIcon />}
                    sx={{
                      bgcolor: "darkBlue.light",
                      color: "white.main",
                      textTransform: "none",
                      "&:hover": {
                        bgcolor: "darkBlue.main",
                      },
                    }}
                    onClick={getDetailPG}
                  >
                    <Typography
                      sx={{ fontWeight: "bold", color: "white.main" }}
                    >
                      Search
                    </Typography>
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Grid>
          <Grid item sm={6} md={6} lg={6}>
            <Box
              sx={{
                borderLeft: 1,
                borderColor: "#c6c6c6",
                paddingLeft: "16px",
                minHeight: "100%",
              }}
            >
              <FormControl className={"fullHeight"} fullWidth sx={{ ml: 1.25 }}>
                <InputLabel shrink htmlFor="select-multiple-native">
                  Product Group Name
                </InputLabel>
                <Select
                  multiple
                  native
                  size="small"
                  //value={productGroupNameLocal}
                  value={productGroupName}
                  onChange={updateProductGroup}
                  label="Select Product Group"
                  inputProps={{
                    id: "select-multiple-native",
                  }}
                  style={{ width: "97%" }}
                >
                  {productGroups.map((pg, index) => {
                    return (
                      <option key={index} value={pg.productGroupName}>
                        {pg.productGroupName} --{pg.status}
                      </option>
                    );
                  })}
                </Select>
              </FormControl>
            </Box>
          </Grid>
        </Grid>
      </Box>

      {/* PRODUCT GROUP NAME, FROM DATE, TO DATE, STATUS */}
      <Box sx={{ mt: 3 }}>
        {/* <Typography className="compHeading"
					sx={{ fontWeight: "bold", color: "blue.main", mb: 2, }}
					gutterBottom
				>
					Define Product Group Parameters
				</Typography> */}
        <CollapseSection title="Define Product Group Parameters">
          <Grid container spacing={3} columns={12} sx={{ mt: 1 }}>
            <Grid item sm={6} md={6} lg={4}>
              <TextField
                label="Product Group Name"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="end">
                      <EditIcon />
                    </InputAdornment>
                  ),
                  autoComplete: "off"
                }}
                //disabled
                variant="outlined"
                value={eProductGroupName}
                onChange={updateEditPGName}
              />
            </Grid>

            <Grid item sm={6} md={6} lg={3}>
              <Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    disabled
                    label="From"
                    value={fromDate}
                    onChange={(newValue) => updateFromDate(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{ width: sizes.w200 }}
                      />
                    )}
                    format="DD/MM/YYYY"
                  />
                </LocalizationProvider>
              </Box>
            </Grid>

            <Grid item sm={6} md={6} lg={3}>
              <Box>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    minDate={minDate}
                    disabled={productGroup?.isDeactivated == 1 ? true : false}
                    label="To"
                    value={toDate}
                    onChange={(newValue) => updateToDate(newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{ width: sizes.w200 }}
                      />
                    )}
                    format="DD/MM/YYYY"
                  />
                </LocalizationProvider>
              </Box>
            </Grid>

            <Grid item sm={6} md={6} lg={2}>
              <Status label={status} />
            </Grid>
          </Grid>
        </CollapseSection>
      </Box>
    </Box>
  );
}
